export const COMPANY = {
  name: "DXHOLIDAYS",
  phone: "+91 86556 47143",
  phoneHref: "tel:+918655647143",
  email: "dxholidays1@gmail.com",
  whatsapp:
    "https://wa.me/918655647143?text=Hi%20DXHOLIDAYS%2C%20I%20want%20to%20enquire%20about%20a%20holiday%20package.",
  address:
    "Office No-5, Shri Ram Krishna Chs Ltd Building, Sector-40, Seawoods, Navi Mumbai – 400706",
};

export const HERO_VIDEO =
  "https://videos.pexels.com/video-files/2169880/2169880-hd_1920_1080_30fps.mp4";

export const SERVICES = [
  {
    id: "holidays",
    title: "Custom Holiday Packages",
    description:
      "Tailor-made domestic and international itineraries with handpicked 4-star and 5-star stays, private transfers and curated experiences.",
    image:
      "https://images.unsplash.com/photo-1590523277543-a94d2e4eb00b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
  },
  {
    id: "flights",
    title: "Flight Booking",
    description:
      "Domestic and international air tickets at exclusive fares, with flexible dates, group bookings and complete assistance.",
    image:
      "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
  },
  {
    id: "bus",
    title: "Bus & Luxury Coach Booking",
    description:
      "AC Volvo, sleeper and luxury coach bookings across major Indian routes — comfortable, punctual and hassle-free.",
    image:
      "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
  },
];

export const DESTINATIONS = {
  india: [
    {
      slug: "goa",
      name: "Goa Tropical Escape",
      tagline: "Sun, sand & luxury beach resorts",
      duration: "4 Days / 3 Nights",
      image:
        "https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
      highlights: ["Beach Resort Stay", "Catamaran Cruise", "Water Sports"],
    },
    {
      slug: "kerala",
      name: "Kerala Backwaters & Houseboats",
      tagline: "God's Own Country",
      duration: "5 Days / 4 Nights",
      image:
        "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
      highlights: ["Private Houseboat", "Munnar Tea Gardens", "Alleppey Cruise"],
    },
    {
      slug: "taj-mahal",
      name: "Taj Mahal & Golden Triangle",
      tagline: "Agra, Delhi & royal heritage",
      duration: "6 Days / 5 Nights",
      image:
        "https://images.unsplash.com/photo-1564507592333-c60657eea523?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
      highlights: ["Sunrise Taj Visit", "Agra Fort Tour", "Luxury Stays"],
    },
    {
      slug: "jaipur",
      name: "Royal Jaipur & Rajasthan",
      tagline: "The Pink City experience",
      duration: "5 Days / 4 Nights",
      image:
        "https://images.unsplash.com/photo-1599661046289-e31897846e41?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
      highlights: ["Hawa Mahal", "Amer Fort Dinner", "Heritage Haveli Stay"],
    },
  ],
  international: [
    {
      slug: "dubai",
      name: "Dubai Skyline & Desert",
      tagline: "Futuristic luxury & safari",
      duration: "6 Days / 5 Nights",
      image:
        "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
      highlights: ["Burj Khalifa Entry", "Desert Safari Dinner", "Dhow Cruise"],
    },
    {
      slug: "maldives",
      name: "Maldives Overwater Villa",
      tagline: "Pure turquoise island escape",
      duration: "5 Days / 4 Nights",
      image:
        "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
      highlights: ["Water Villa", "Seaplane Transfer", "All-Inclusive Dining"],
    },
    {
      slug: "bali",
      name: "Bali Island & Ubud Retreat",
      tagline: "Tropical sanctuaries",
      duration: "7 Days / 6 Nights",
      image:
        "https://images.unsplash.com/photo-1537996194471-e657df975ab4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
      highlights: ["Infinity Pool Villa", "Rice Terrace Tour", "Temple Sunset"],
    },
    {
      slug: "srilanka",
      name: "Sri Lanka Tea Trails & Coast",
      tagline: "The pearl of the Indian Ocean",
      duration: "6 Days / 5 Nights",
      image:
        "https://images.unsplash.com/photo-1546708973-b339540b5162?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
      highlights: ["Ella Scenic Train", "Sigiriya Rock", "Bentota Beach"],
    },
    {
      slug: "bangkok",
      name: "Bangkok & Pattaya Getaway",
      tagline: "Temples, markets & nightlife",
      duration: "5 Days / 4 Nights",
      image:
        "https://images.unsplash.com/photo-1508009603885-50cf7c579365?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
      highlights: ["Grand Palace Tour", "Coral Island Trip", "Floating Market"],
    },
  ],
};

export const BRAND_VIDEOS = [
  {
    title: "Turquoise Horizons",
    subtitle: "Island escapes we craft",
    url: "https://videos.pexels.com/video-files/3571264/3571264-hd_1920_1080_30fps.mp4",
    poster:
      "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
  },
  {
    title: "The Rhythm of the Sea",
    subtitle: "Coastal journeys, DX style",
    url: "https://videos.pexels.com/video-files/1093662/1093662-hd_1920_1080_30fps.mp4",
    poster:
      "https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
  },
  {
    title: "Shores That Call",
    subtitle: "Beach holidays & beyond",
    url: "https://videos.pexels.com/video-files/1409899/1409899-hd_1920_1080_25fps.mp4",
    poster:
      "https://images.unsplash.com/photo-1590523277543-a94d2e4eb00b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
  },
];

export const MARQUEE_ITEMS = [
  "LUXURY HOLIDAYS",
  "FLIGHT BOOKING",
  "BUS TICKETS",
  "GOA BEACHES",
  "KERALA BACKWATERS",
  "DUBAI SKYLINE",
  "MALDIVES RESORTS",
  "BALI RETREATS",
  "SRI LANKA TRAILS",
  "BANGKOK NIGHTS",
];
